import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import styled from '@emotion/styled';

import CONST from '../constants';

const StyledCode = styled.p`
    display: inline-block;
    padding: 0 1vw;
    margin: 0;
    border-bottom: 1vw solid;
    color: ${CONST.COLOR.THEME_SECONDARY};
    font-size: 10vw;
    font-weight: bold;
    z-index: 2;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        padding: 0 5px;
        border-bottom: 5px solid;
        font-size: 50px;
    }
`;

const StyledMessage = styled.p`
    margin: 1vw 0 0;
    color: ${CONST.COLOR.THEME_SECONDARY};
    font-size: 10vw;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        margin-top: 5px;
        font-size: 50px;
    }
`;

const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: ${CONST.HEADER_HEIGHT.MOBILE};
    background: ${CONST.COLOR.CREAM};
    z-index: 1;

    @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
        padding-top: ${CONST.HEADER_HEIGHT.STATIC};
    }
`;

const GenericNotFound = () => {
    return (
        <Background>
            <Container className="pt-5 pb-1">
                <Row>
                    <Col className='text-center'>
                        <StyledCode>404</StyledCode>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center'>
                        <StyledMessage>Not Found</StyledMessage>
                    </Col>
                </Row>
            </Container >
        </Background>
    );
};

export default GenericNotFound;
